import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function AutoLogoutCountdown () {
  const [inactivityTime] = useEnvValue('inactivity_time', 0)

  return Math.max(0, 65 - inactivityTime)
}
